module.exports = __webpack_public_path__ + "static/media/page-screen-left.1b65f48f.png";